import { useEffect, useState, useMemo, useCallback } from "react";
import { AgGridReact } from "ag-grid-react";
import { toast } from "react-toastify";
import { Toast } from "../../../../config/Toast";
import { FormatSalaryItem } from "../../../../helper/ResponseSalary";
import { ReportColumn } from "./Column";
import ReportAction from "./Action";
import Pagination from "../../../../components/Pagination";
import Report from "../../../../services/Report";
import "react-loading-skeleton/dist/skeleton.css";
import moment from "moment";

const DisbursmentWorkerReport = () => {
  const [rowData, setRowData] = useState([]);
  const [search, setSearch] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [totalPage, setTotalPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingFilter, setLoadingFilter] = useState(false);

  const limitDataPages = 10;

  const notifySuccess = useCallback((message) => {
    toast.success(message, Toast);
  }, []);

  const notifyFailed = useCallback((message) => {
    toast.error(message, Toast);
  }, []);

  const fetchData = useCallback(async () => {
    if (!startDate || !endDate) return;

    try {
      setLoading(true);
      const response = await Report.disbursmentWorkerNew(pageNumber, limitDataPages, search, startDate, endDate);

      const { data = [], total_page = 0 } = response?.data || {};
      const formattedData = FormatSalaryItem(data, pageNumber, limitDataPages);

      setRowData(formattedData);
      setTotalPage(total_page);
    } catch (err) {
      const message = err?.response?.data?.message || "Terjadi kesalahan saat memuat data rekapitulasi.";
      notifyFailed(`Gagal memuat data rekapitulasi: ${message}`);
    } finally {
      setLoading(false);
    }
  }, [pageNumber, search, startDate, endDate, notifyFailed]);

  useEffect(() => {
    if (startDate && endDate) {
      fetchData();
    }
  }, [fetchData, startDate, endDate]);

  const handleDateChange = useCallback((dates) => {
    if (Array.isArray(dates) && dates.length === 2) {
      setStartDate(moment(dates[0]).format("YYYY-MM-DD"));
      setEndDate(moment(dates[1]).format("YYYY-MM-DD"));
      setPageNumber(1);
    }
  }, []);

  const handleSearch = useCallback((val) => {
    setSearch(val || "");
    setPageNumber(1);
  }, []);

  const handleFilter = useCallback(async () => {
    if (!startDate || !endDate) {
      notifyFailed("Periode rentang waktu tidak boleh kosong");
      return;
    }
    try {
      setLoadingFilter(true);
      await fetchData();
      notifySuccess("Filter berhasil diterapkan");
    } catch {
      notifyFailed("Gagal menerapkan filter");
    } finally {
      setLoadingFilter(false);
    }
  }, [startDate, endDate, fetchData, notifyFailed, notifySuccess]);

  const handleChangePage = useCallback(({ selected }) => {
    setPageNumber(selected + 1);
  }, []);

  const colDefs = useMemo(() => ReportColumn(), []);

  return (
    <div className="w-100 d-flex flex-column gap-3">
      <ReportAction
        onDateChange={handleDateChange}
        onFilter={handleFilter}
        onSearch={handleSearch}
        loadingFilter={loadingFilter}
      />

      <div
        className="ag-theme-alpine w-100"
        style={{
          height: `${Math.max(50 * (rowData.length || 5) + 50, 250)}px`,
          overflow: "auto",
        }}
      >
        <AgGridReact
          rowData={loading ? [] : rowData}
          columnDefs={colDefs}
          domLayout="normal"
          theme="legacy"
          rowHeight={50}
          headerHeight={50}
          animateRows={true}
          enableCellTextSelection={true}
          sideBar={false}
          defaultColDef={{
            sortable: true,
            filter: false,
            resizable: true,
          }}
          overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Memuat data...</span>'}
          overlayNoRowsTemplate={'<span class="ag-overlay-loading-center">Tidak ada data</span>'}
        />
      </div>

      {totalPage > 0 && <Pagination pageCount={totalPage} forcePage={pageNumber - 1} changePage={handleChangePage} />}
    </div>
  );
};

export default DisbursmentWorkerReport;
